module.exports = __webpack_public_path__ + "static/agenda-6efa3f72f84ebe114fdedaecfe86e20a.jpg";